import { render, staticRenderFns } from "./TagsSetup.vue?vue&type=template&id=6ac56fda&"
import script from "./TagsSetup.vue?vue&type=script&lang=js&"
export * from "./TagsSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports